var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "headlines-container" },
    [
      _vm.category === "BettingHeadlines" &&
      (_vm.currentBoNavigationHeadlines &&
        _vm.currentBoNavigationHeadlines.length > 0)
        ? _c("v-container", { class: ["headlines"], attrs: { fluid: "" } }, [
            !_vm.mobileBigAndBelow
              ? _c(
                  "div",
                  { staticClass: "headline-big" },
                  [
                    _c(
                      "v-carousel",
                      {
                        style: { height: this.carouselHeight },
                        attrs: {
                          interval: _vm.rotationInterval,
                          "hide-delimiters": "",
                          cycle: _vm.cycleRotation
                        }
                      },
                      _vm._l(_vm.currentBoNavigationHeadlines, function(
                        headline,
                        index
                      ) {
                        return _c("v-carousel-item", {
                          key: index,
                          class: [
                            {
                              active:
                                headline.idfwheadline ===
                                _vm.selectedTab.idfwheadline
                            },
                            { "hover-headline": headline.location !== null }
                          ],
                          staticStyle: {
                            height: "auto",
                            "min-height": "280px"
                          },
                          attrs: { src: headline.imageurl },
                          on: { notify: _vm.setIndex },
                          nativeOn: {
                            click: function($event) {
                              return _vm.goToHeadlineLink(headline)
                            }
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.mobileBigAndBelow
              ? _c(
                  "div",
                  { staticClass: "headline-mobile" },
                  [
                    _c(
                      "v-carousel",
                      {
                        class: { mobile: _vm.mobile },
                        attrs: { "hide-controls": "" }
                      },
                      _vm._l(_vm.currentBoNavigationHeadlines, function(
                        headline,
                        index
                      ) {
                        return _c("v-carousel-item", {
                          key: index,
                          staticStyle: {
                            height: "100%",
                            "background-size": "contain",
                            "background-position": "center"
                          },
                          style: {
                            backgroundImage: "url(" + headline.imageurl + ")"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.goToHeadlineLink(headline)
                            }
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.category === "BettingHeadlines" &&
      (!_vm.currentBoNavigationHeadlines ||
        _vm.currentBoNavigationHeadlines.length === 0)
        ? _c("div")
        : _vm._e(),
      _vm._v(" "),
      _vm.category === "SidebarBanners" &&
      (_vm.currentBoNavigationHeadlines &&
        _vm.currentBoNavigationHeadlines.length > 0)
        ? _c("v-container", { class: ["headlines"], attrs: { fluid: "" } }, [
            !_vm.mobileBigAndBelow
              ? _c(
                  "div",
                  { staticClass: "headline-big" },
                  [
                    _c(
                      "v-carousel",
                      {
                        style: { height: this.carouselHeight },
                        attrs: {
                          interval: _vm.rotationInterval,
                          "hide-delimiters": "",
                          cycle: _vm.cycleRotation,
                          "hide-controls": ""
                        }
                      },
                      _vm._l(_vm.currentBoNavigationHeadlines, function(
                        headline,
                        index
                      ) {
                        return _c("v-carousel-item", {
                          key: index,
                          class: [
                            {
                              active:
                                headline.idfwheadline ===
                                _vm.selectedTab.idfwheadline
                            },
                            { "hover-headline": headline.location !== null }
                          ],
                          staticStyle: {
                            height: "auto",
                            "min-height": "280px"
                          },
                          attrs: { src: headline.imageurl },
                          on: { notify: _vm.setIndex },
                          nativeOn: {
                            click: function($event) {
                              return _vm.goToHeadlineLink(headline)
                            }
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46db9fc9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46db9fc9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/headlinesLight.vue
// module id = null
// module chunks = 